/* lp40sub-e4 — E2の価格・送料・購入挙動を保ったE4用スクリプト
 *
 * 個数×間隔ピッカー本体、レビューカルーセル、スクロール演出、CTA計測は
 * lp40sub-c3.js がそのまま担当する。ここはその上に足すぶんだけを持つ。
 *
 * E1からの一番の違い:
 *   お届け先を選ぶまで総額を出さない。
 *   E1は関東を例に「総額4,680円」を大きく出していたが、関東以外の人にとっては
 *   自分の金額ではないので、確かめ直す手間が増える。
 *   購入カードでは送料幅を先に強調せず、地域を選んだ時点で明細と総額を出す。
 *
 * このファイルがやること:
 *   1. 個数と地域から、送料・総額・1個あたり・お得額を出す
 *   2. 地域を選ぶまで総額を隠す（固定CTAも同じ扱いにする）
 *   3. お客様の声を、商品ページへ飛ばさずにこのページで追加表示する
 *   4. カルーセルを指で触れたら自動で切り替わらないようにする
 *   5. 固定CTAをファーストビューを過ぎてから出す
 *
 * c3 側の内部状態には触らない。自動再生の一時停止は、c3 が既に持っている
 * mouseenter / mouseleave の口を使って外から知らせる。
 * 送料と総額に data-lp3-ship / data-lp3-total を使わないこと。
 * それらは c3.js が関東の値で上書きしてしまう。E2は data-e2-* を使う。
 *
 * 固定CTAの出し入れに requestAnimationFrame のスロットルを使わないこと。
 * 読み込み時にタブが裏にあるとコールバックが来ず、実行中フラグが立ったままになって
 * それ以降のスクロールが全部素通りする。読むのは要素1つの矩形だけなので直接呼ぶ。
 *
 * JSが動かない環境では、購入カードのCTAは安全な選択欄へのリンクを保持する。
 * 購入リンクへの切替と、送料込み総額の確定はJavaScriptが動く場合だけ行う。
 */
(function () {
  'use strict';
  if (window.__lp40subE4) return;
  window.__lp40subE4 = true;

  function lpVersion() {
    return (document.body && document.body.getAttribute('data-lp-version')) || 'e4';
  }

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function num(el, attr) {
    return parseInt((el && el.getAttribute(attr)) || '0', 10) || 0;
  }
  function push(payload) {
    if (typeof window.__suecoLpTrack === 'function') {
      window.__suecoLpTrack(payload);
    }
  }

  /* ============ 1・2. 個数 × お届け先 ============ */
  function initPrice() {
    var qtyInputs = all('input[name="lp3-qty"]');
    var freqInputs = all('input[name="lp3-freq"]');
    var selects = all('[data-e2-region]');
    if (!qtyInputs.length) return;

    var regionValue = '';

    function checkedQty() {
      for (var i = 0; i < qtyInputs.length; i++) if (qtyInputs[i].checked) return qtyInputs[i];
      return qtyInputs[0];
    }

    function checkedFrequency() {
      for (var i = 0; i < freqInputs.length; i++) {
        if (freqInputs[i].checked && !freqInputs[i].disabled) return freqInputs[i];
      }
      return null;
    }

    function syncRegionRequiredCtas(hasRegion) {
      all('[data-e2-region-required]').forEach(function (cta) {
        var enabled = hasRegion && cta.hasAttribute('href');
        cta.classList.toggle('is-disabled', !enabled);
        if (enabled) {
          cta.removeAttribute('aria-disabled');
          cta.removeAttribute('tabindex');
        } else {
          cta.setAttribute('aria-disabled', 'true');
          cta.setAttribute('tabindex', '-1');
        }
      });
    }

    function currentOption() {
      if (!selects.length || regionValue === '') return null;
      var opts = all('option', selects[0]);
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].value === regionValue) return opts[i];
      }
      return null;
    }

    function shipRange(size) {
      var opts = selects.length ? all('option[data-ship80]', selects[0]) : [];
      var min = 0;
      var max = 0;
      opts.forEach(function (o) {
        var v = num(o, size === '60' ? 'data-ship60' : 'data-ship80');
        if (!v) return;
        if (!min || v < min) min = v;
        if (v > max) max = v;
      });
      return { min: min, max: max };
    }

    function sync() {
      var q = checkedQty();
      if (!q) return;
      var f = checkedFrequency();

      var qty = num(q, 'data-qty');
      var price = num(q, 'data-price');
      var once = num(q, 'data-once');
      var size = q.getAttribute('data-size') === '60' ? '60' : '80';
      var save = once > price ? once - price : 0;
      var unit = qty > 0 ? Math.round(price / qty) : 0;
      var discount = once > 0 ? Math.round(save * 100 / once) : 0;
      var packCount = qty > 0 ? Math.round(qty / 10) : 0;
      var frequencyLabel = f ? f.getAttribute('data-label') : '月1回';
      var range = shipRange(size);

      all('[data-e2-save], [data-e1-save]').forEach(function (e) { e.textContent = yen(save); });
      all('[data-e2-unit], [data-e1-unit]').forEach(function (e) { e.textContent = yen(unit); });
      all('[data-e2-once]').forEach(function (e) { e.textContent = yen(once); });
      all('[data-e2-discount]').forEach(function (e) { e.textContent = discount; });
      all('[data-e2-packcount]').forEach(function (e) { e.textContent = packCount; });
      all('[data-e2-frequency]').forEach(function (e) { e.textContent = frequencyLabel; });
      all('[data-e2-price]').forEach(function (e) { e.textContent = yen(price); });
      all('[data-e2-qty], [data-e1-qty]').forEach(function (e) { e.textContent = qty + '個'; });
      all('[data-e2-shiprange]').forEach(function (e) {
        e.textContent = range.min ? yen(range.min) + '円〜' + yen(range.max) + '円' : '';
      });

      // 地域別の一覧（開いたときだけ見る側）も、選んだ個数に合わせておく
      all('[data-e1-region]').forEach(function (row) {
        var rowShip = num(row, size === '60' ? 'data-ship60' : 'data-ship80');
        var s = row.querySelector('[data-e1-region-ship]');
        var t = row.querySelector('[data-e1-region-total]');
        if (s) s.textContent = yen(rowShip) + '円';
        if (t) t.textContent = yen(price + rowShip) + '円';
      });

      var opt = currentOption();
      var stickyNote;

      if (opt) {
        var ship = num(opt, size === '60' ? 'data-ship60' : 'data-ship80');
        var total = price + ship;
        all('[data-e2-ship]').forEach(function (e) { e.textContent = yen(ship); });
        all('[data-e2-total]').forEach(function (e) { e.textContent = yen(total); });
        all('[data-e2-regionname]').forEach(function (e) { e.textContent = opt.textContent; });
        all('[data-e2-totalwrap]').forEach(function (e) { e.removeAttribute('hidden'); });
        all('[data-e2-region-hint]').forEach(function (e) { e.setAttribute('hidden', ''); });
        all('[data-e2-sticky-amt]').forEach(function (e) { e.textContent = yen(total) + '円'; });
        syncRegionRequiredCtas(true);
        stickyNote = '／1回（商品' + yen(price) + '円＋' + opt.textContent + '送料' + yen(ship) + '円）';
      } else {
        all('[data-e2-totalwrap]').forEach(function (e) { e.setAttribute('hidden', ''); });
        all('[data-e2-region-hint]').forEach(function (e) { e.removeAttribute('hidden'); });
        all('[data-e2-sticky-amt]').forEach(function (e) { e.textContent = yen(price) + '円'; });
        syncRegionRequiredCtas(false);
        stickyNote = '／1回・お届け先を選ぶと送料込み総額を表示';
      }
      all('[data-e2-sticky-note]').forEach(function (e) { e.textContent = stickyNote; });
    }

    qtyInputs.forEach(function (el) { el.addEventListener('change', sync); });
    freqInputs.forEach(function (el) { el.addEventListener('change', sync); });

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        regionValue = sel.value;
        selects.forEach(function (other) { if (other !== sel) other.value = regionValue; });
        sync();
        if (regionValue !== '') {
          push({
            event: 'lp_region_select',
            lp_version: lpVersion(),
            region: sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent : ''
          });
        }
      });
    });

    sync();
  }

  /* ============ 3. お客様の声を、このページで追加表示する ============ */
  function initMoreReviews() {
    all('[data-e1-more], [data-e2-more]').forEach(function (btn) {
      var list = document.getElementById(btn.getAttribute('aria-controls') || '');
      if (!list) return;

      btn.addEventListener('click', function () {
        list.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        push({
          event: 'lp_review_more',
          lp_version: lpVersion(),
          review_count: all('.lp3-rv', list).length
        });
        var first = list.querySelector('.lp3-rv');
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
        var wrap = btn.parentNode;
        if (wrap) wrap.removeChild(btn);
      });
    });
  }

  /* ============ 4. 指で触れているあいだは自動で切り替えない ============ */
  function initTouchPause() {
    all('[data-lp3-carousel]').forEach(function (car) {
      var timer = null;

      function pause() {
        car.dispatchEvent(new MouseEvent('mouseenter'));
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          car.dispatchEvent(new MouseEvent('mouseleave'));
        }, 30000);
      }

      car.addEventListener('touchstart', function (e) {
        if (e.target && e.target.closest && e.target.closest('.lp3-play, .lp3-nav, .lp3-dots')) return;
        pause();
      }, { passive: true });
    });
  }

  /* ============ 5. 固定CTAはファーストビューを過ぎてから ============ */
  function initSticky() {
    var bar = document.querySelector('.lp3-sticky');
    var hero = document.querySelector('.lp3-hero');
    if (!bar || !hero) return;

    bar.classList.add('lp3e-sticky');

    function check() {
      bar.classList.toggle('lp3e-sticky-off', hero.getBoundingClientRect().bottom >= 48);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    check();
  }

  /* ============ 計測 ============ */
  function initTracking() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var soft = e.target.closest('[data-e1-softcta], [data-e2-softcta]');
      if (soft) {
        push({
          event: 'lp_soft_cta_click',
          lp_version: lpVersion(),
          cta_location: soft.getAttribute('data-cta-location') || ''
        });
      }
    });

    all('[data-e1-regions]').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        push({
          event: 'lp_region_table_open',
          lp_version: lpVersion(),
          cta_location: d.getAttribute('data-cta-location') || ''
        });
      });
    });

    push({ event: 'lp_view', lp_version: lpVersion() });
  }

  /* ============ 合わせ買い商品（手動スクロールのみ） ============ */
  function initAddonCarousel() {
    all('[data-e4-addon]').forEach(function (root) {
      var track = root.querySelector('[data-e4-addon-track]');
      var prev = root.querySelector('[data-e4-addon-prev]');
      var next = root.querySelector('[data-e4-addon-next]');
      if (!track) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      function stepSize() {
        var card = track.querySelector('[data-e4-addon-card]');
        if (!card) return track.clientWidth;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function updateButtons() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      }

      function move(direction) {
        track.scrollBy({
          left: stepSize() * direction,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      }

      if (prev) prev.addEventListener('click', function () { move(-1); });
      if (next) next.addEventListener('click', function () { move(1); });
      track.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  function boot() {
    initPrice();
    initMoreReviews();
    initTouchPause();
    initSticky();
    initTracking();
    initAddonCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
